import React from 'react';
import Header from '../components/Header';
import {translate} from 'react-i18next';
import {connect} from 'react-redux';
import {
	navigationBack,
	navigationToWorkout,
	resetNavigationToOverview,
} from '../navigation/NavigationActions';
import {CURRENT_PENDING, CURRENT_PAUSE} from '../overview/DayStates';
import WorkoutButton from '../components/MyButton';
import _ from 'lodash';
import './workoutPreview.css';
import {Dialog, CircularProgress} from 'material-ui';
import {colors} from '../styles/colors';
import Round from './Round';
import OptionalRoundTogglers from './OptionalRoundTogglers';
import {
	getOptionalExcercisesConfig,
	saveOptionalExcercisesConfig,
} from '../utils/settingsStore';
import {getWorkout, clearWorkout} from '../utils/workoutStore';
import WipeSlateCleanDialog from '../overview/WipeSlateCleanDialog';
import moment from 'moment';

function WorkoutPreview({
	goBack,
	t,
	workout,
	goToWorkout,
	setExcerciseToPreview,
	isCooldownToggled,
	isWarmupToggled,
	onWarmupToggle,
	onCooldownToggle,
}) {
	const {warmups, cooldowns, excercises} = workout;
	const workoutsByRound = _.groupBy(excercises, 'round');
	const isTodaysWorkout = [CURRENT_PENDING, CURRENT_PAUSE].includes(
		workout.state
	);
	return (
		<div className='workoutPreviewWrapper noSelectAtAll'>
			<Header
				onBackPress={() => goBack()}
				title={t('overview:workout')}
				colored
				cta={
					isTodaysWorkout && (
						<WorkoutButton
							style={{
								height: 35,
								background: '#fff',
								color: colors.primaryColor,
							}}
							onPressButton={() => {
								goToWorkout();
							}}
							title='start'
							color='primary'
							size='large'
							variant='raised'
						/>
					)
				}
			/>
			<div
				className='excercisePreviewWrapper'
				style={{paddingTop: isTodaysWorkout ? 180 : 120}}
			>
				<OptionalRoundTogglers
					onWarmupToggle={onWarmupToggle}
					onCooldownToggle={onCooldownToggle}
					isWarmupToggled={isWarmupToggled}
					isCooldownToggled={isCooldownToggled}
					warmupLabel={t('workout:withOptionalWarmup')}
					cooldownLabel={t('workout:withOptionalCooldown')}
				/>
				{isWarmupToggled && warmups && !!warmups.length && (
					<Round
						t={t}
						round={warmups}
						roundNumber={'warmups'}
						onItemPress={setExcerciseToPreview}
						textAfterImg={'5 min'}
					/>
				)}
				{Object.keys(workoutsByRound).map((round) => (
					<Round
						onItemPress={setExcerciseToPreview}
						key={round}
						t={t}
						round={workoutsByRound[round]}
						roundNumber={round}
						textAfterImg={`${t('common:of')} ${
							Object.keys(workoutsByRound).length
						}`}
					/>
				))}
				{isCooldownToggled && cooldowns && !!cooldowns.length && (
					<Round
						round={cooldowns}
						t={t}
						roundNumber={'cooldowns'}
						onItemPress={setExcerciseToPreview}
						textAfterImg={'5 min'}
					/>
				)}
			</div>
		</div>
	);
}
const defaultState = {
	excerciseToPreview: '',
	isLoadingPreview: false,
	wantsWarmup: true,
	wantsCooldown: true,
	isWipeSlateCleanDialogOpen: false,
};

class WorkoutPreviewContainer extends React.Component {
	constructor(props) {
		super(props);
		const config = getOptionalExcercisesConfig();
		const {wantsCooldown, wantsWarmup} = config;
		this.state = {
			...defaultState,
			wantsWarmup,
			wantsCooldown,
		};
	}

	setExcerciseToPreview = (id) => {
		this.setState({
			excerciseToPreview: id,
			isLoadingPreview: true,
		});
	};

	onDoWipeSlate = () => {
		const {wantsWarmup, wantsCooldown} = this.state;
		saveOptionalExcercisesConfig({
			wantsWarmup,
			wantsCooldown,
		});
		clearWorkout();
		this.setState({
			isWipeSlateCleanDialogOpen: false,
		});
	};

	onDontWipeSlate = () => {
		const {wantsWarmup, wantsCooldown} = getOptionalExcercisesConfig();
		this.setState({
			wantsWarmup,
			wantsCooldown,
			isWipeSlateCleanDialogOpen: false,
		});
	};

	toggleExcerciseSet = (excerciseSet) => (val) => {
		this.setState({
			[excerciseSet]: val,
		});
		const isTodaysWorkout = [CURRENT_PENDING].includes(
			this.props.workout.state
		);

		// toggling warmups/cooldown for morgen's workout
		// don't ask questions and dont update config.
		if (!isTodaysWorkout) {
			return;
		}
		const workoutInProgress = getWorkout();
		const nextConfig = {
			...getOptionalExcercisesConfig(),
			[excerciseSet]: val,
		};

		if (!workoutInProgress) {
			saveOptionalExcercisesConfig(nextConfig);
		} else {
			// get saved workout finish deadline
			const {workoutId} = workoutInProgress;
			const {_id} = this.props.workout;

			// is saved workout's deadline passed ?
			if (workoutId !== _id) {
				clearWorkout();
				saveOptionalExcercisesConfig(nextConfig);
				return;
			}

			this.setState({
				isWipeSlateCleanDialogOpen: true,
			});
		}
	};

	getTargetExcercise = () => {
		if (!this.state.excerciseToPreview) return;
		const {cooldowns, warmups, excercises} = this.props.workout;
		const allExcercises = [
			...(Array.isArray(cooldowns) ? cooldowns : []),
			...(Array.isArray(warmups) ? warmups : []),
			...(Array.isArray(excercises) ? excercises : []),
		];
		if (!allExcercises.length) return;
		const targetEx = allExcercises.find(
			({_id}) => _id === this.state.excerciseToPreview
		);

		if (!targetEx) return;
		return targetEx.excercise_info;
	};
	componentDidMount() {
		if (!Object.keys(this.props.workout).length) {
			this.props.returnToOverview();
		}
	}
	render() {
		return (
			<React.Fragment>
				<Dialog open={!!this.state.excerciseToPreview}>
					<div className='workoutPreviewVideoWrapper'>
						{!!this.state.isLoadingPreview &&
							!!this.state.excerciseToPreview && (
								<div className='indicatorWrapper'>
									<CircularProgress
										color='primary'
										size={36}
									/>
								</div>
							)}
						{this.getTargetExcercise() && (
							<video
								style={{
									opacity: this.state.isLoadingPreview
										? 0
										: 1,
								}}
								onCanPlay={() => {
									this.setState({isLoadingPreview: false});
								}}
								playsInline
								autoPlay
								loop
								poster={this.getTargetExcercise().video_image}
								src={this.getTargetExcercise().video}
								height='70%'
								width='100%'
							></video>
						)}
					</div>

					<div
						style={{
							paddingTop: 20,
							paddingBottom: 20,
							textAlign: 'center',
						}}
					>
						<WorkoutButton
							style={{
								height: 35,
								background: colors.primaryColor,
								color: colors.white,
							}}
							onPressButton={() => {
								this.setExcerciseToPreview('');
							}}
							title={this.props.t('common:dismiss')}
							color='secondary'
							size='large'
							variant='raised'
						/>
					</div>
				</Dialog>
				<WorkoutPreview
					workout={this.props.workout}
					goBack={this.props.goBack}
					goToWorkout={this.props.goToWorkout}
					t={this.props.t}
					setExcerciseToPreview={this.setExcerciseToPreview}
					isCooldownToggled={this.state.wantsCooldown}
					isWarmupToggled={this.state.wantsWarmup}
					onWarmupToggle={this.toggleExcerciseSet('wantsWarmup')}
					onCooldownToggle={this.toggleExcerciseSet('wantsCooldown')}
				/>
				<WipeSlateCleanDialog
					t={this.props.t}
					onDeny={this.onDontWipeSlate}
					onClose={this.onDontWipeSlate}
					onAccept={this.onDoWipeSlate}
					isOpen={this.state.isWipeSlateCleanDialogOpen}
				/>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		workout: state.workout,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		goBack: () => dispatch(navigationBack()),
		goToWorkout: () => dispatch(navigationToWorkout()),
		returnToOverview: () => dispatch(resetNavigationToOverview()),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(translate(['workout', 'common'])(WorkoutPreviewContainer));



// WEBPACK FOOTER //
// ./src/workoutPreview/workoutPreview.js